<script lang="ts" setup>
import AccordionButton from "@src/components/ui/data-display/AccordionButton.vue";
import Collapse from "@src/components/ui/utils/Collapse.vue";
import LabeledSelectInput from "@src/components/ui/inputs/LabeledSelectInput.vue";
import NotificationsSwitch from "@src/components/ui/inputs/NotificationsSwitch.vue";
import {ref} from "vue";
import {useAuthStore} from "@src/stores/auth";
import NotificationsService from "@src/services/notifications";

const authStore = useAuthStore();
const props = defineProps<{
    collapsed: boolean;
    handleToggle: () => void;
}>();

const selectedNotification = ref(
    authStore.user?.settings.notification ?? "notification1.mp3"
);

let audio: HTMLAudioElement | null = null;

const playNotification = () => {
    if (audio) {
        audio.pause();
        audio.currentTime = 0;
    }
    audio = new Audio(NotificationsService.soundMap[selectedNotification.value]);
    audio.play();
};

const changeSound = (notification: string) => {
    NotificationsService.setNotification(notification);
    selectedNotification.value = notification;
    if (authStore.user) {
        authStore.user.settings.notification = notification;
    }
};

</script>

<template>
    <AccordionButton
        id="appearance-settings-toggler"
        :collapsed="props.collapsed"
        aria-controls="appearance-settings-collapse"
        chevron
        class="w-full flex px-5 py-6 mb-3 rounded focus:outline-none"
        @click="props.handleToggle()"
    >
        <p class="heading-2 text-black/70 dark:text-white/70 mb-1">Notificações</p>
        <p class="body-2 text-black/70 dark:text-white/70">
            Gerencie suas notificações
        </p>
    </AccordionButton>

    <Collapse id="appearance-settings-collapse" :collapsed="props.collapsed">
        <div class="px-5 pb-5 space-y-6">
            <NotificationsSwitch description="Receber todas as notificações" title="Conversas do Robô" value="bots"/>

            <NotificationsSwitch description="Receber todas as notificações" title="Conversas de Grupos" value="groups"/>

            <div class="flex justify-between items-center">
                <div class="flex-1">
                    <LabeledSelectInput
                        id="notification"
                        :value="selectedNotification"
                        label="Som de notificação"
                        @value-changed="changeSound"
                    >
                        <template #endAdornment>

                        </template>

                        <option v-for="n in 6" :key="n" :value="`notification${n}.mp3`" class="text-gray-800 bg-gray-100 dark:bg-gray-700 dark:text-gray-300">
                            Notificação {{ n }}
                        </option>
                    </LabeledSelectInput>
                </div>

                <button
                    :title="`Ouvir ${selectedNotification}`"
                    class="h-full px-3 flex items-center text-black/50 hover:text-black dark:text-white/50 dark:hover:text-white transition-colors"
                    type="button"
                    @click="playNotification"
                >
                    <svg
                        class="w-[22px] h-[22px] text-gray-500 hover:text-brand-400 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/>
                    </svg>
                </button>
            </div>
        </div>
    </Collapse>
</template>